import { render, staticRenderFns } from "./RegisterButton.vue?vue&type=template&id=8f500dda&scoped=true"
import script from "./RegisterButton.vue?vue&type=script&lang=js"
export * from "./RegisterButton.vue?vue&type=script&lang=js"
import style0 from "./RegisterButton.vue?vue&type=style&index=0&id=8f500dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f500dda",
  null
  
)

export default component.exports